import { Navigate, useLocation } from 'react-router-dom';

function App() {
    const location = useLocation();
    const message = location.state?.message;

    return <Navigate to="/painel/" state={{ message }} replace />;
}

export default App;
